import { render, staticRenderFns } from "./cms-block-cards.vue?vue&type=template&id=336b53b3&scoped=true"
import script from "./cms-block-cards.vue?vue&type=script&lang=js"
export * from "./cms-block-cards.vue?vue&type=script&lang=js"
import style0 from "./cms-block-cards.vue?vue&type=style&index=0&id=336b53b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336b53b3",
  null
  
)

export default component.exports